var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 182,
    viewBox: "0 0 1920 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2200 91V153H2148.33V91V29H2096.67V91V153H2045V91V29H1993.33V91V153H1941.67V91V29H1890V91V153H1838.33V91V29H1786.67V91V153H1735V91V29H1683.33V91V153H1631.67V91V29H1580V91V153H1528.33V91V29H1476.67V91V153H1425V91V29H1373.33V91V153H1321.67V91V29H1270V91V153H1218.33V91V29H1166.67V91V153H1115V91V29H1063.33V91V153H1011.67V91V29H960V91V153H908.333V91V29H856.667V91V153H805V91V29H753.333V91V153H701.667V91V29H650V91V153H598.333V91V29H546.667V91V153H495V91V29H443.333V91V153H391.667V91V29H340V91V153H288.333V91V29H236.667V91V153H185V91V29H133.333V91V153H81.6666V91V29H30V91V153H-21.6667V91V29H-73.3334V91V153H-125V91V29H-176.667V91V153H-228.333V91V29H-280V91",
    stroke: "url(#paint0_radial_1081_7708)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1081_7708",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(960 -64.9999) rotate(89.681) scale(932.001 907.314)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D34646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareWave);
export default __webpack_public_path__ + "static/media/squareWave.97b14089312367a7fbd62cdf7e0e26d9.svg";
export { ForwardRef as ReactComponent };